export default "__VITE_ASSET__D$FJdskQ__"